module.exports = __webpack_public_path__ + "img/content7-5.1d71f12e.webp";